<template>
  <div class="row">
    <div class="col-12">
      <div class="row col-12">
        <div class="col-12 row mb-2">
          <h5 class="col-12 row col-sm-3 ">
            {{ $t('OS Preventiva Programada Armazém') }}
          </h5>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <div class="col-sm-6 col-12">
            <button @click="gerarPreditivas = true" class="alert alert-danger text-capitalize cardIndicador" style="background-image: linear-gradient(45deg, rgb(12, 100, 52), rgb(8, 255, 131)) !important;"> {{ $t('Gerar OS Preventiva Programada') }}</button>
          </div>
        </div>
      </div>
    </div>
    <modal-preditivas @gerarPreditivas="gerarPreditivas = false" @refresh="applyFilters" v-if="gerarPreditivas"></modal-preditivas>
  </div>
</template>

<script>
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ModalPreditivas from './Modais/ModalPreditivas.vue'

momentDurationFormatSetup(moment)

export default {
  data() {
    return {
      gerarPreditivas: false,
    }
  },

  components: {
    ModalPreditivas,
  },

  created(){
  },

  mounted() {
    this.$store.dispatch('os/fetchMediaLiberacao', { filial: this.$root.filial.nr_sequencial })

    const filial = this.$store.getters['filial/filial']

    if(filial.fornecExt == "S"){
      this.showFornecExt = false
    }
  },

  computed: {


    totalPlacasAVencer(){
      const total = this.$store.getters['osItem/totalplacasAVencer']

      return total
    },
    
  },

  methods: {
    
  }
}
</script>
<style scoped>

.cardIndicador{
  color: #fff!important;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 25px; 
  text-align: center;
  border: none;
}
.btnLimparFiltro{
  background: transparent;
  border: 1px solid #c9c9c9;
  margin-left: 13px;
}
.col-md-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.66667%;
    flex: 0 0 24.66667%;
    max-width: 24.66667%;
}
</style>